import { OptionImg } from "../Image";

export const htmlDecode = (content) => {
  if(!content) return "";
  const e = document.createElement("body");
  e.innerHTML = content;

  const nodes = [];
  for (let childIndex = 0; childIndex < e.childNodes.length; childIndex++) {
    const node = e.childNodes[childIndex];
    if (node.nodeName === "#text") nodes.push(node.nodeValue);
    else nodes.push(node.outerHTML);
  }
  const nodeText = nodes.join("");
  return nodeText;
};


export default function Option(props) {
  return (
    <label className="option" style={props.styles}>
      <span
        className="option-text"
        style={{textTransform:props.isTF?"capitalize":""}}
        dangerouslySetInnerHTML={{
          __html: htmlDecode(props.option?.value || "-"),
        }}
      ></span>
      <input
        type={props.type || "checkbox"}
        value={props.option.optionId}
        className="radio"
        onClick={props.select}
        name="radio"
      />
      <div className="checkmark" style={props.checkmarkStyles}>
        <span></span>
      </div>
      {/**Option image */}
      <OptionImg image={props.image} />
    </label>
  );
}
